import { RateType } from "./storage-rule-mysuffix.model";

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}
/* export const enum RateType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT'
} */
export interface IRuleExtensionRateMySuffix {
    id?: number;
    rate?: number;
    activeStatus?: ActiveStatus;
    ruleId?: number;
    extensionsId?: number;
    extensionsName?: string;
    rateType?:RateType
}

export class RuleExtensionRateMySuffix implements IRuleExtensionRateMySuffix {
    constructor(
        public id?: number,
        public rate?: number,
        public activeStatus?: ActiveStatus,
        public ruleId?: number,
        public extensionsId?: number,
        public extensionsName?: string,
        public rateType?:RateType
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        this.rateType = RateType.PERCENTAGE;
    }
}
